import type { SVGProps } from 'react'

export function FluentShieldError16Filled(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      role="img"
      aria-label="icon"
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      viewBox="1 1 14 14"
      {...props}
    >
      {/* Icon from Fluent UI System Icons by Microsoft Corporation - https://github.com/microsoft/fluentui-system-icons/blob/main/LICENSE */}
      <path
        fill="currentColor"
        d="M8.355 2.147a.5.5 0 0 0-.708 0C6.404 3.388 5.03 4 3.5 4a.5.5 0 0 0-.5.5v3.001c0 3.219 1.641 5.407 4.842 6.473a.5.5 0 0 0 .316 0C11.358 12.908 13 10.72 13 7.501V4.5a.5.5 0 0 0-.5-.5c-1.531 0-2.905-.61-4.145-1.853M8.5 5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 1 0m-.5 6A.75.75 0 1 1 8 10a.75.75 0 0 1 0 1.5"
      />
    </svg>
  )
}
